import Footer from "../../components/Footer"
import NavbarPrivate from "../../components/navbar/NavbarPrivate"
import { EmailSubscriptionEnum, PublicCourseSchema } from "../../api"
import useApi from "../../hooks/useApi"
import useAuthedApi from "../../hooks/useAuthedApi"
import { useState, useEffect, useRef } from "react"
import { useParams, useNavigate, Link } from "react-router-dom"
import { isAxiosError } from "axios"
// import { Alert, Button, Modal, TextInput } from "flowbite-react"
import { Alert, Button, Modal } from "flowbite-react"
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/solid"
// import ModalCustom from "../../components/modals/ModalCustom"
import useAuth from "../../hooks/useAuth"
import NavbarPublic from "../../components/navbar/NavbarPublic"
// import { HiCurrencyEuro } from "react-icons/hi"
import ARTE_CAN from "../../assets/images/ARTE_CAN.png"
import Syllabus from "../../components/Syllabus"
import FAQs from "../../components/FAQs"
import ReactPlayer from "react-player/youtube"
import useToasts from "../../hooks/useToasts"
import Loading from "../../components/Loading"

const Course = () => {
  const { toastList, setToastList } = useToasts()
  const [course, setCourse] = useState<PublicCourseSchema>()
  const [loading, setLoading] = useState(true)
  const { CoursesApi } = useApi()
  const { UsersAuthedApi } = useAuthedApi()
  // const { CoursesAuthedApi } = useAuthedApi()
  const navigate = useNavigate()
  const { slug } = useParams()
  const [errMsg, setErrMsg] = useState("")
  const errRef = useRef<HTMLInputElement>(null)
  // const [quantity, setQuantity] = useState<string>("1")
  // const [validQuantity, setValidQuantity] = useState(false)
  // const [quantityFocus, setQuantityFocus] = useState(false)
  // const [errModalMsg, setErrModalMsg] = useState("")
  // const errModalRef = useRef<HTMLInputElement>(null)
  const { auth, setAuth } = useAuth()
  const [showAuthModal, setShowAuthModal] = useState(false)

  const getCourse = async (slug: string) => {
    try {
      const response = await CoursesApi.coursesReadCourse(slug)
      if (!response.data) {
        setErrMsg("Get course failed with unknown error")
        return
      }
      // console.log(JSON.stringify(response?.data))

      setCourse(response.data)
      setLoading(false)
    } catch (err) {
      if (isAxiosError(err)) {
        if (!err?.response) {
          setErrMsg("No server response")
        } else if (err.response?.status === 404) {
          setErrMsg("We could not find that course")
        } else if (err.response?.status === 422) {
          setErrMsg("Data validation error")
        } else {
          setErrMsg("Get course failed with unknown error")
        }
      } else {
        setErrMsg("Get course failed with unknown error")
      }
      errRef.current?.focus()
    }
  }

  useEffect(() => {
    if (!slug) {
      navigate("/courses")
      return
    }

    getCourse(slug)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug])

  const get_notified = async () => {
    if (!auth?.user) {
      setShowAuthModal(true)
      return
    }

    try {
      const response = await UsersAuthedApi.usersUpdateUserMe({
        first_name: auth.user.first_name,
        last_name: auth.user.last_name,
        company: auth.user.company,
        email_subscriptions: auth.user.email_subscriptions.concat(
          EmailSubscriptionEnum.Arte
        ),
      })
      if (!response.data.success) {
        setErrMsg("Notification settings update failed with unknown error")
        return
      }
      // console.log(JSON.stringify(response?.data))
      let auth2 = auth
      if (!auth2?.user) {
        return
      }
      auth2.user.email_subscriptions = auth.user.email_subscriptions.concat(
        EmailSubscriptionEnum.Arte
      )
      setAuth(auth2)
      setToastList(
        toastList.concat({
          type: "success",
          children: "Notification settings updated successfully!",
        })
      )
    } catch (err) {
      if (isAxiosError(err)) {
        console.log(err)
        if (!err.response?.status) {
          setErrMsg("No server response")
        } else if (err.response?.status === 404) {
          setErrMsg("User not found")
        } else if (err.response?.status === 422) {
          setErrMsg("Data validation error")
        } else {
          setErrMsg("Notification settings update failed with unknown error")
        }
      } else {
        setErrMsg("Notification settings update failed with unknown error")
      }
      errRef.current?.focus()
    }
  }

  // const buy = async (slug: string, quantity: string) => {
  //   const q = parseInt(quantity)
  //   if (q < 1) {
  //     setErrModalMsg("Invalid data, quantity must be larger than 0")
  //     return
  //   }

  //   if (!auth?.user) {
  //     setShowAuthModal(true)
  //     return
  //   }

  //   try {
  //     const response = await CoursesAuthedApi.coursesBuyCourse({
  //       slug: slug,
  //       quantity: parseInt(quantity),
  //     })
  //     if (!response.data) {
  //       setErrModalMsg("Course purchase failed with unknown error")
  //       return
  //     }
  //     // console.log(JSON.stringify(response?.data))

  //     window.location.href = response.data.url
  //   } catch (err) {
  //     if (isAxiosError(err)) {
  //       if (!err?.response) {
  //         setErrModalMsg("No server response")
  //       } else if (err.response?.status === 404) {
  //         setErrModalMsg("We could not find that course")
  //       } else if (err.response?.status === 422) {
  //         setErrModalMsg("Data validation error")
  //       } else {
  //         setErrModalMsg("Course purchase failed with unknown error")
  //       }
  //     } else {
  //       setErrModalMsg("Course purchase failed with unknown error")
  //     }
  //     errModalRef.current?.focus()
  //   }
  // }

  // useEffect(() => {
  //   const q = parseInt(quantity)
  //   setValidQuantity(q >= 1)
  // }, [quantity])

  return (
    <section className="h-screen flex flex-col">
      {auth ? <NavbarPrivate /> : <NavbarPublic />}

      <div className="mb-auto flex-1 overflow-y-auto">
        <div className="container mx-auto">
          <section id="courses">
            <div className={!errMsg ? "sr-only" : ""}>
              <Alert
                color="failure"
                icon={ExclamationTriangleIcon}
                onDismiss={function onDismiss() {
                  setErrMsg("")
                }}
              >
                <span ref={errRef}>{errMsg}</span>
              </Alert>
            </div>
            <Modal
              show={showAuthModal}
              size="md"
              popup={true}
              onClose={() => {
                setShowAuthModal(false)
              }}
            >
              <Modal.Header />
              <Modal.Body>
                <div className="text-center">
                  <ExclamationCircleIcon className="mx-auto mb-4 h-14 w-14 text-red-500 dark:text-red-200" />
                  <h3 className="mb-5 text-lg font-normal text-white">
                    You need to sign in to make a purchase
                  </h3>
                  <div className="flex justify-center gap-4">
                    <Button
                      as={Link}
                      to="/signin"
                      outline={true}
                      className="ml-3 text-white bg-gradient-to-br from-red-500 via-red-logo to-red-900 hover:bg-gradient-to-bl !border-red-logo focus:ring-red-900 dark:focus:ring-red-900 focus:!ring-2"
                    >
                      Sign in
                    </Button>
                    <Button
                      as={Link}
                      to="/signup"
                      className="ml-3 text-white bg-gradient-to-br from-red-500 via-red-logo to-red-900 hover:bg-gradient-to-bl !border-red-logo focus:ring-red-900 dark:focus:ring-red-900 focus:!ring-2"
                    >
                      Create an account
                    </Button>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
            {loading ? (
              <Loading />
            ) : (
              <>
                {course ? (
                  <div>
                    <div className="md:flex justify-center items-center mt-8">
                      <div>
                        <img
                          src={ARTE_CAN}
                          className="md:mr-3 md:h-56"
                          alt="HackTricks Training Logo"
                        />
                      </div>
                      <div className="">
                        <h1 className="text-3xl md:text-5xl font-bold text-center dark:text-white mt-8 md:mt-0">
                          HACKTRICKS ARTE
                        </h1>
                        <h1 className="text-5xl font-bold text-amber-500">
                          20+
                        </h1>
                        <h2 className="text-2xl md:text-3xl font-medium text-center dark:text-white">
                          {course
                            ? course?.title.toUpperCase()
                            : "No course data"}
                        </h2>
                      </div>
                    </div>
                    {course.prereleased ? (
                      <div className="w-full">
                        <Alert
                          className="my-6 md:w-1/2 lg:w-1/3 mx-3 md:mx-auto"
                          color="warning"
                          icon={ExclamationTriangleIcon}
                        >
                          This course is in pre-release <br />
                          The predicted release date is {course.release_date}
                        </Alert>
                      </div>
                    ) : (
                      <></>
                    )}

                    <div className="mx-3 md:mx-16 mt-6 md:mt-10">
                      <ReactPlayer
                        controls={true}
                        width="100%"
                        height="100%"
                        className="aspect-video"
                        url="https://www.youtube.com/watch?v=FIgyJcWQcuE"
                      />
                    </div>
                    <div className="mt-6 md:mt-10 mx-3 md:mx-16 grid grid-cols-1 sm:grid-cols-2 justify-items-center dark:text-white">
                      <div className="px-10 md:px-12 mt-5 md:mt-12">
                        <h3 className="text-xl md:text-2xl font-bold text-center dark:text-white">
                          IN-DEPTH AWS SECURITY TRAINING
                        </h3>
                        <p className="text-justify mt-3 md:mt-5">
                          {course ? course?.description : "No course data"}
                        </p>
                      </div>
                      <div className="px-10 md:px-12 mt-5 md:mt-12">
                        <h3 className="text-xl md:text-2xl font-bold text-center dark:text-white">
                          GET HACKTRICKS ARTE CERTIFIED
                        </h3>
                        <p className="text-justify mt-3 md:mt-5">
                          Energize your cloud security career by obtaining the
                          prestigious HackTricks ARTE (AWS Red Team Expert)
                          certification. This highly sought-after credential
                          validates your expertise in AWS security and red
                          teaming, standing out in the field and opening up new
                          career opportunities
                        </p>
                      </div>
                    </div>

                    <div className="mx-3 md:mx-16 mt-10 md:mt-10 grid grid-cols-1 sm:grid-cols-2 justify-items-center dark:text-white">
                      <div className="flex px-10 md:px-12 mt-5 md:mt-10 items-center">
                        <div className="flex-none">
                          <h1 className="text-5xl font-bold text-amber-500">
                            20+
                          </h1>
                        </div>
                        <div className="grow ml-3">
                          <h3 className="text-xl font-bold">
                            HOURS OF VIDEO LESSONS
                          </h3>
                        </div>
                      </div>
                      <div className="flex px-10 md:px-12 mt-5 md:mt-10 items-center">
                        <div className="flex-none">
                          <h1 className="text-5xl font-bold text-amber-500">
                            70+
                          </h1>
                        </div>
                        <div className="grow ml-3">
                          <h3 className="text-xl font-bold">
                            ESTIMATED HOURS COMPLETION TIME
                          </h3>
                        </div>
                      </div>
                      <div className="flex px-10 md:px-12 mt-5 md:mt-10 items-center">
                        <div className="flex-none">
                          <h1 className="text-5xl font-bold text-amber-500">
                            50+
                          </h1>
                        </div>
                        <div className="grow ml-3">
                          <h3 className="text-xl font-bold">
                            HANDS-ON LABS TO TRAIN
                          </h3>
                        </div>
                      </div>
                      <div className="flex px-10 md:px-12 mt-5 md:mt-10 items-center">
                        <div className="flex-none">
                          <h1 className="text-5xl font-bold text-amber-500">
                            1
                          </h1>
                        </div>
                        <div className="grow ml-3">
                          <h3 className="text-xl font-bold">
                            EXAM TO PROVE YOUR KNOWLEDGE
                          </h3>
                        </div>
                      </div>
                    </div>

                    <Syllabus syllabus={course.syllabus} />
                    <div className="my-6 md:my-10 mx-3 md:mx-16 md:flex md:flex-row justify-items-center dark:text-white">
                      <div className="basis-full md:basis-2/3 px-3 md:px-5 my-10 md:my-12 w-full">
                        <ReactPlayer
                          controls={true}
                          width="100%"
                          height="100%"
                          className="aspect-video"
                          url="https://www.youtube.com/watch?v=oQUtvnJ4Idc"
                        />
                      </div>
                      <div className="basis-full md:basis-1/3 px-3 md:px-5 my-10 md:my-12">
                        <h3 className="text-xl md:text-2xl font-bold text-center dark:text-white">
                          PREVIEW ARTE LESSON
                        </h3>
                        <p className="text-justify mt-3 md:mt-5">
                          For you to get a feel of what this course is like we
                          have made part of our Red Team Methodology lesson
                          publicly available.
                        </p>
                      </div>
                    </div>
                    {/* {course.promotion ? (
                  <div className="mt-20 text-base leading-relaxed text-neutral-700 dark:text-white  text-center ">
                    <span className="text-lg font-medium">
                      Promotion: -{course.promotion}%
                    </span>
                    <div className="flex justify-center text-lg font-medium">
                      <HiCurrencyEuro size={26} className="align-middle" />
                      <span>Price:</span>
                      <span className="ml-2 text-red-700 dark:text-red-500 line-through">
                        {course.price}€
                      </span>
                      <span className="ml-2 text-green-600 dark:text-green-400">
                        {course.price * (course.promotion / 100)}€
                      </span>
                    </div>
                  </div>
                ) : (
                  <div className="mt-20 text-base leading-relaxed text-neutral-700 dark:text-white text-center">
                    <div className="flex justify-center text-lg font-medium">
                      <HiCurrencyEuro size={26} className="align-middle" />
                      <span>Price:</span>
                      <span className="ml-2">{course.price}€</span>
                    </div>
                  </div>
                )} */}
                    {/* <ModalCustom title={"Get " + course.title + " now"}>
                  <div className="p-6">
                    <div className="space-y-6">
                      <div className={!errModalMsg ? "sr-only" : ""}>
                        <Alert
                          color="failure"
                          icon={ExclamationTriangleIcon}
                          onDismiss={function onDismiss() {
                            setErrModalMsg("")
                          }}
                        >
                          <span ref={errModalRef}>{errModalMsg}</span>
                        </Alert>
                      </div>
                      {course.prereleased ? (
                        <Alert color="warning" icon={ExclamationTriangleIcon}>
                          This course is in pre-release <br />
                          The predicted release date is {course.release_date}
                        </Alert>
                      ) : (
                        <></>
                      )}
                      <div className="text-base leading-relaxed text-neutral-700 dark:text-white">
                        Includes:
                        <ul className="list-disc list-inside">
                          <li>20+ hours of video lessons</li>
                          <li>1 month access to labs</li>
                          <li>1 certification exam attempt</li>
                        </ul>
                      </div>
                      {course.promotion ? (
                        <div className="text-base leading-relaxed text-neutral-700 dark:text-white  text-center ">
                          <span className="text-red-700 dark:text-red-500 line-through">
                            Price: {course.price}€
                          </span>
                          <br />
                          Promotion: - {course.promotion}% <br />
                          <span className="text-green-600 dark:text-green-400">
                            New price:
                            {course.price * (course.promotion / 100)}€
                          </span>
                        </div>
                      ) : (
                        <div className="text-base leading-relaxed text-neutral-700 dark:text-white text-center">
                          Price: {course.price}€
                        </div>
                      )}

                      <div className="flex flex-col items-center">
                        <TextInput
                          id="quantity"
                          type="number"
                          placeholder="1"
                          addon="Quantity"
                          required={true}
                          onChange={(e) => {
                            if (
                              parseInt(e.target.value) > 0 ||
                              e.target.value === ""
                            ) {
                              setQuantity(e.target.value)
                            }
                          }}
                          onFocus={() => setQuantityFocus(true)}
                          onBlur={() => setQuantityFocus(false)}
                          value={quantity}
                          aria-invalid={validQuantity ? "false" : "true"}
                          color={
                            validQuantity ? "" : !quantity ? "" : "failure"
                          }
                          theme={{ field: { base: "relative w-16" } }}
                          helperText={
                            <>
                              <span
                                className={
                                  quantityFocus && quantity && !validQuantity
                                    ? ""
                                    : "sr-only"
                                }
                              >
                                <ExclamationCircleIcon className="mr-3 inline h-5 w-5 flex-shrink-0" />
                                Invalid quantity, must be greater than 0
                              </span>
                            </>
                          }
                        />
                      </div>
                      {course.promotion ? (
                        <div className="text-base leading-relaxed text-neutral-700 dark:text-white text-center ">
                          <span className="text-red-700 dark:text-red-500 line-through">
                            Total:
                            {course.price * (quantity ? parseInt(quantity) : 0)}
                            €
                          </span>
                          <br />
                          Promotion: - {course.promotion}% <br />
                          <span className="text-green-600 dark:text-green-400">
                            New total:
                            {course.price *
                              (course.promotion / 100) *
                              (quantity ? parseInt(quantity) : 0)}
                            €
                          </span>
                        </div>
                      ) : (
                        <div className="text-base leading-relaxed text-neutral-700 dark:text-white text-center">
                          Total:
                          {course.price * (quantity ? parseInt(quantity) : 0)}€
                        </div>
                      )}
                      <div className="flex flex-col items-center">
                        <Button
                          className="items-center text-neutral-700 dark:text-white bg-gradient-to-br from-red-500 via-red-logo to-red-900 hover:bg-gradient-to-bl !border-red-logo focus:ring-red-900 dark:focus:ring-red-900 focus:!ring-2"
                          type="button"
                          onClick={() => buy(course.slug, quantity)}
                          disabled={!validQuantity}
                        >
                          Buy now
                        </Button>
                      </div>
                    </div>
                  </div>
                </ModalCustom> */}
                    {course.prereleased ? (
                      <div className="w-full">
                        {auth &&
                        auth.user?.email_subscriptions.includes(
                          EmailSubscriptionEnum.Arte
                        ) ? (
                          <Alert
                            className="my-6 md:w-1/2 lg:w-1/3 mx-3 md:mx-auto"
                            color="success"
                            icon={CheckCircleIcon}
                          >
                            You are signed up for course update notifications
                          </Alert>
                        ) : (
                          <>
                            <Alert
                              className="my-6 md:w-1/2 lg:w-1/3 mx-3 md:mx-auto"
                              color="warning"
                              icon={ExclamationTriangleIcon}
                            >
                              Don't miss out! Get notified when the course is
                              released
                            </Alert>
                            <div className="flex flex-col items-center mb-6">
                              <Button
                                className="items-center text-neutral-700 dark:text-white bg-gradient-to-br from-red-500 via-red-logo to-red-900 hover:bg-gradient-to-bl !border-red-logo focus:ring-red-900 dark:focus:ring-red-900 focus:!ring-2"
                                type="button"
                                onClick={() => {
                                  get_notified()
                                }}
                              >
                                GET NOTIFIED
                              </Button>
                            </div>
                          </>
                        )}
                      </div>
                    ) : (
                      <></>
                    )}

                    <FAQs faqs={course.faqs} />
                  </div>
                ) : (
                  <p>No course to display</p>
                )}
              </>
            )}
          </section>
        </div>
        <Footer />
      </div>
    </section>
  )
}

export default Course
